import React from 'react';
import classnames from 'classnames';
import Spinner from '../Loader.jsx';

const LandingPageSkeleton = () => {
  const componentClass = 'landingPage';
  const classes = classnames(componentClass, `${componentClass}--skeleton`);

  return (
    <div className={classes}>
      <div className={`loader__skeleton_container`}>
        <Spinner></Spinner>
      </div>
    </div>
  );
};

export default LandingPageSkeleton;
